"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapOwnerIsActiveFlag = mapOwnerIsActiveFlag;
exports.getUserId = getUserId;

function getRemoteHubSpotUser(owner) {
  return owner.remoteList.filter(function (remoteItem) {
    return remoteItem.get('remoteType') === 'HUBSPOT';
  }).first();
}

function mapOwnerIsActiveFlag(ownerWithRoles, owner) {
  var remoteUser = getRemoteHubSpotUser(owner);
  return remoteUser ? ownerWithRoles.set('isActive', remoteUser.get('active')) : ownerWithRoles;
}

function getUserId(owner) {
  var remoteUser = getRemoteHubSpotUser(owner);

  if (remoteUser) {
    return parseInt(remoteUser.get('remoteId'), 10);
  }

  return null;
}